// eslint-disable-next-line eqeqeq
export const OAUTH_ENABLED = process.env.REACT_APP_OAUTH == 'enabled'
export const PARAMS = {
    EMAIL: 'emailId',
    ORGID: 'orgId',
    USER_ID: 'userId',
    TYPE: 'type'
}
export const REFERRER = 'referrer'
export const LOGIN = 'login'
export const LOGIN_EMAIL = 'email'
export const IS_ADMIN = 'isAdmin'
export const ORGANIZATION = {
    orgName: 'orgName'
}
export const Login = {
    statusKey: 'loginStatus',
    organizationDetailsKey: 'organizationLoginDetails',
    userId: 'userId'
}

export const LOGIN_STATUS = {
    valid: 'Valid',
    invalid: 'Invalid'
}

export const paramReplacer = (URL, key, value) => {
    return URL.replace('{' + key + '}', value)
}
export const LOGUSERPARAMS = [ PARAMS.ORGID, PARAMS.EMAIL, PARAMS.USER_ID, PARAMS.TYPE ]
export const SUCCESS = 200
export const UNAUTHORIZED = 401
export const SERVICE_UNAVAILABLE = 503
export const INTERNAL_SERVER_ERROR = 500
export const NO_CONTENT = 204
export const BAD_REQUEST = 400
export const CREATED = 201
export const LOGTYPE = {
    LOGIN: 1,
    LOGOUT: 2
}
